import { TFunction } from 'i18next';
import { DateTimeCell, YesNoCell } from '@components-clean/core/grid-fe/custom-cells';
import { GridColumnProps } from '@components-clean/core/grid-fe/grid.interface';

export const columnDefs = (t: TFunction): GridColumnProps[] => [
    {
        id: 'isACtive',
        title: t('admin:manageCMIntegration.history.active'),
        field: 'isActive',
        filter: 'boolean',
        cells: {
            data: YesNoCell,
        },
    },
    {
        id: 'fileName',
        title: t('admin:manageCMIntegration.history.fileName'),
        field: 'fileName',
        filter: 'text',
    },
    {
        id: 'uploadedBy',
        title: t('admin:manageCMIntegration.history.uploadedBy'),
        field: 'uploadedByFullName',
        filter: 'text',
    },
    {
        id: 'uploadedDate',
        title: t('admin:manageCMIntegration.history.uploadedDate'),
        field: 'uploadedDate',
        filter: 'date',
        cells: {
            data: DateTimeCell('DD-MMM-yyyy HH:mm:ss'),
        },
    },
];
